<template>
  <CContainer fluid>
    <h3>Pedidos</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6">
            <CInput 
              label="Buscar:"
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
        </CRow>
        <CDataTable 
          hover 
          :items="items" 
          :fields="fields"
          :items-per-page="itemsPerPage" 
          :responsive=true>
          <template #documento="{item}">
            <td>
              <h4>{{ item.numero }}</h4>
            </td>
          </template>
          <template #empresa="{item}">
              <td>
                <div>
                  <span><CIcon name="cil-building" class="mr-1"/>{{ item.empresa }}</span>
                </div>
                <div>
                  <span><i class="bi bi-postcard mr-1" style="height: 1rem; width: 1rem; display: inline-block;"></i>{{ item.identificacion }}</span>
                </div>
                <div>
                  <i class="bi bi-person-workspace mr-1"></i>
                  <span>{{ item.empleado }}</span>
                </div>
              </td>
          </template>
          <template #fechas="{item}">
            <td>
              <div>
                <CIcon name="cil-calendar" class="mr-1"/>
                <span>
                  {{ moment(item.fecha_Emision).format('DD/MM/YYYY') }}
                </span>
              </div>
              <div>
                <CBadge 
                  :color="getBadgeColor(item.estado)">
                  {{ orderState[item.estado] }}
                </CBadge>
              </div>
            </td>
          </template>
          <template #valores="{item}">
            <td>
              <div class="d-flex justify-content-end">
                <strong>${{ formatter.format(item.valor_Total) }}</strong>
              </div>
            </td>
          </template>
          <template #info="{item}">
            <td>
              <a href="#"
                class="mb-2 p-2"
                style="text-decoration: none;"
                @click="toggleDocument($event, item)">
                <CIcon class="text-dark" :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'"/>
              </a>
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <div class="d-flex justify-content-end mb-2">
                  <!-- <a href="#"
                    class="m-2"
                    @click="event => {
                      event.stopPropagation()
                      $store.commit('set', ['selectedQuote', item.id_Pedido])
                      $router.push(
                        {
                          path: `/empresa/movimientos/cotizaciones/editarcotizacion`
                        }
                      )
                    }">
                    <CIcon name="cil-pencil" size="lg" class="text-warning"></CIcon>
                  </a> -->
                  <!-- <a href="#"
                    class="m-2"
                    @click="tryDelete(item.Id_Pedido)">
                    <CIcon name="cil-trash" size="lg" class="text-danger"></CIcon>
                  </a> -->
                  <!-- <i class="bi bi-clipboard-check"></i> -->

                  <!-- <a href="#" 
                    class="m-2" 
                    @click="event => openRightSidebarComments(event, item)">
                    <i class="bi bi-chat-square-text text-warning h4"></i>
                  </a> -->
                  <!-- <a href="#" 
                    class="m-2" 
                    @click="openModalProfit(item.Id_Pedido)">
                    <i class="bi bi-clipboard-data text-s3green h4"></i>
                  </a> -->
                  <!-- <a href="#"
                    class="m-2"
                    @click="event => openRightSidebarComments(event, item)">
                    <i class="bi bi-journal-check text-s3purple h4"></i>
                  </a> -->
                  <!-- <a href="#" 
                    class="m-2" 
                    v-c-tooltip="'Seguimiento Pedido'" 
                    @click="(event) => openPanelTracking(event, item.id_Pedido)">
                    <Icon icon="hugeicons:delivery-tracking-01" class="text-s3fuchsia h4" />
                  </a> -->

                <!-- ToDo -->
                 <a href="#" 
                  class="m-2" 
                  @click="(event) => tryDelete(event, item.id_Pedido)">
                  <i class="bi bi-bag-x text-danger h4"></i>
                </a>

                  <!-- <a href="#" 
                    class="mr-3" 
                    v-c-tooltip="'Cargar Documento Anexo'"
                    @click="openPanelUploadAttachment($event, item.id_Pedido)">
                    <Icon icon="fluent:document-arrow-up-20-regular" class="text-s3fuchsia h3" />
                  </a> -->


                <a href="#" 
                  class="m-2" 
                  v-c-tooltip="'Documentos Anexos'" 
                  @click="openPanelAttachments($event, item.id_Pedido)">
                  <Icon icon="teenyicons:attachment-outline" class="text-s3brown h4 mt-1" />
                </a>

                <a href="#" 
                  class="m-2" 
                  v-c-tooltip="'Genera formato para compras'"
                  @click="printPurchaseRequestPDF(item.id_Pedido)">
                  <!-- <Icon icon="fluent-mdl2:add-to-shopping-list" class="h4 mt-1" /> -->
                  <Icon icon="lets-icons:arhive-alt-add-list-light" class="h2" />
                  <!-- <i class="bi bi-journal-bookmark h4"></i> -->
                </a>
                <a href="#" 
                  class="m-2" 
                  v-c-tooltip="'Imprimir pedido PDF'"
                  @click="printOrderPDF(item.id_Pedido)">
                  <i class="bi bi-file-earmark-pdf text-danger h4"></i>
                </a>
              </div>
              <CCol col="sm-6" class="d-inline-block" style="vertical-align: top;">
                <div>
                  <strong>Orden Compra: </strong>{{item.orden_Compra}}
                </div>
                <div>
                  <strong>Comentarios: </strong>
                </div>
                <div>
                  <strong></strong>{{item.comentario_01}}
                </div>
                <div>
                  <strong></strong>{{item.comentario_02}}
                </div>
              </CCol>
              <CCol col="sm-6" class="d-inline-block" style="vertical-align: top;">
                <div class="ml-4 row">
                  <strong class="col-sm-6">Vr. Mercancía: </strong>
                  <span class="col-sm-6 text-right">{{formatter.format(item.valor_Mercancia)}}</span>
                </div>
                <div class="ml-4 row">
                  <strong class="col-sm-6">Vr. IVA: </strong>
                  <span class="col-sm-6 text-right">{{formatter.format(item.valor_Iva)}}</span>
                </div>
                <div class="ml-4 row">
                  <strong class="col-sm-6">Vr. Total: </strong>
                  <span class="col-sm-6 text-right">
                    <strong>
                      {{formatter.format(item.valor_Total)}}
                    </strong>
                  </span>
                </div>
              </CCol>
            </CCollapse>
          </template>
        </CDataTable>

        <CPagination 
          size="sm" 
          class="d-flex justify-content-center"
          :activePage.sync="page" 
          :pages="pageCount" 
          @update:activePage="(value, a) => getData(value, searchWord)" />
      </CCardBody>

      <CElementCover v-show="loading">
        <div class="text-dark p-3 text-center">
          <img src="@/assets/images/blocks-shuffle.svg" alt="Spinner" height="24" width="24" />
          <h4 class="ml-2">Cargando...</h4>
        </div>
      </CElementCover>
    </CCard>

  
    <!-- Panel sidebar para agregar documentos anexos -->
    <RightSideBar size="md" class="bg-s3grey" :show="showPanelUploadAttachment">
      <FormAttachments 
        :idDocument="idDocumento" 
        :key="updateComponentAttachments" 
        @closeWindow="closePanelAttachments">
      </FormAttachments>
    </RightSideBar>

    <!-- Panel sidebar para visualizar los documentos anexos -->
    <RightSideBar size="md" class="bg-s3grey" :show="showPanelAttachments">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Documentos Anexos
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <AttachedDocuments v-if="showPanelAttachments" 
              typeQuery="pedido" 
              :id="idDocumento">
            </AttachedDocuments>
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify content-center">
              <CButton 
                color="primary"
                class="ml-2"
                @click="showPanelAttachments=false">
                <CIcon name="cil-x-circle"></CIcon>
                <span class="align-middle ml-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

    <!-- <RightSideBar size="md" class="bg-s3grey" :show="showPanelTracking">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Seguimiento de Pedido
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
              <ul class="metro_tmtimeline">
                <li v-for="(reg, idx) in estados" :class="reg.color" :key="idx">
                    <div class="metro_tmicon">
                      <i class="bi bi-check-lg"></i>
                    </div>
                    <div class="metro_tmlabel">
                        <h3>{{ reg.tipo_Documento }}</h3>
                        <div>
                          <span>{{ reg.prefijo }} {{ reg.numero }}</span>
                        </div>
                        <span>{{ moment(reg.fecha_Emision).format("DD/MM/YYYY") }}</span>
                    </div>
                </li>
              </ul>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <CButton 
              color="primary" 
              @click="showPanelTracking=false">
              <CIcon name="cil-x-circle"/>
              <span class="align-middle ml-2">Cerrar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar> -->
      
    <!-- <RightSideBar class="bg-s3grey" :show="showRightSidebarComments">
      <VerticalDynamicForm title="Comentarios" :fields="commentsFields" />
      <span>Hola</span>
      <div class="d-flex justify-content-center">
        <CButton
          square 
          color="success"
          class="d-inline-block"
          :class="isValidForm ? '' : 'disabled'"
          :disabled="!isValidForm"
          @click="saveTracking()">
          <CIcon name="cil-check-circle"/>
          <span class="align-middle mx-2">Guardar</span>
        </CButton>
        <CButton
          color="danger"
          variant="outline"
          class="mr-2 d-inline-block"
          @click="(e) => {
            e.stopPropagation()
            showRightSidebarComments = false
          }">
          <CIcon name="cil-x-circle"/>
          <span class="align-middle mx-2">Cancelar</span>
        </CButton>
      </div>
    </RightSideBar> -->

  </CContainer>
</template>

<script>
  import moment from 'moment';
  import { Icon } from "@iconify/vue2";
  import { formatter } from '../../../general'
  import CONSTANTS from "@/constants";
  import { downloadFileObject } from '../../../api';
  import { dataGridSolicitudesPedidos } from "../../../apiDataGrids"
  import { crudPedidoCotizacion } from "@/apiCRUD.js";
  import { dataSeguimientoCotizacion } from "../../../apiData"
  import { 
    descargarCotizacionPDF,
    imprimirSolicitudCompra
  } from "@/apiReports"
  
  import RightSideBar from "../../containers/RightSideBar.vue"
  // import VerticalDynamicForm from "../../containers/VerticalDynamicForm.vue"
  import FormAttachments from "../../forms/FormAttachments.vue";
  import AttachedDocuments from "../../datagrids/AttachedDocuments.vue";

  const fields = [
    { key: 'documento', label: 'Número', _style: 'text-align:center' },
    { key: 'empresa', label: 'Empresa', _style: 'text-align:center' },
    { key: 'fechas', label: 'Fecha', _style: 'text-align:center' },
    { key: 'valores', label: 'Valores', _style: 'text-align:center' },
    { key: 'info', label: '' }
  ]

  export default ({
    name: 'OrdersList',
    data() {
        return {
          formatter,
          loading: false,
          fields,
          page: 1,
          pageCount: 1,
          itemsPerPage: 5,
          searchWord: "",
          showPanelUploadAttachment: null,
          showPanelAttachments: null,
          showRightSidebarComments: null,
          showPanelTracking: null,
          updateComponentAttachments: 0,
          idDocumento: "",
          idSelectedorder: "",
          commentsFields: [
            { 
              key: "comentario01",
              value: "",
              type: "textarea",
              label: ""
            },
            { 
              key: "comentario02",
              value: "",
              type: "textarea",
              label: ""
            }
          ],
          items: [],
          estados: [],
          orderState: {
            CA: "Cargado",
            PA: "Pendiente Aprobación",
            AP: "Aprobado",
            RA: "Rechazado Aprobador",
            PE: "Pendiente",
            AL: "Alistamiento",
            MD: "Mercancía Despachado",
            ME: "Mercancía Entregada",
            EP: "Entrega Parcial",
            ER: "Entrega Rechazada",
            EM: "Entrega Mercancia",
            TO: "Facturado",
            PC: "Pedido Cancelado"
          }
        }
    },
    components: {
      Icon,
      RightSideBar,
      // VerticalDynamicForm
      FormAttachments,
      AttachedDocuments
    },
    methods: {
      moment,
      async getData(page, search) {
        try {
          this.loading = true
          this.searchWord = search

          const { count, results } = await dataGridSolicitudesPedidos(
            this,
            this.$store.state.user.data.tipo_Empleado === "V" ? this.$store.state.user.data.id_Empleado : null,
            page,
            search
          )

          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          }

          this.items = results
        } catch(error) {
          console.log(error)
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      tryDelete(e, idOrder) {
        e.stopPropagation();

        this.idSelectedorder = idOrder;

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar";
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red";

        this.$confirm("¿Confirma que desea borrar el pedido?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
            this.deleteOrder();
        }).catch(() => {
            this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert);
        });
      },
      async deleteOrder() {
        this.loading = true

        try {
          await crudPedidoCotizacion(this, "delete", this.idSelectedorder);

          this.$store.commit("setAlert", {
            color: "success",
            message: CONSTANTS.messages.successfulAction,
            show: 5
          });

          this.getData();
        } catch (error) {
          const { errorCode, errorMessage } = error.data;

          this.$store.commit("setAlert", {
            color: "danger",
            message: `${CONSTANTS.messages.notDoneDelete} Error: (${errorCode}) - ${errorMessage}`,
            show: 5
          })
        } finally {
          this.loading = false;
        }
      },
      async openPanelTracking(e, idDocument) {
        e.stopPropagation()

        this.showPanelTracking = true

        const { response } = await dataSeguimientoCotizacion(this, idDocument)

        this.estados = response
      },
      async printPurchaseRequestPDF(idDocument) {
        this.loading = true

        try {
          const dataBase64 = await imprimirSolicitudCompra(this, idDocument)
          const url = URL.createObjectURL(new Blob([dataBase64], { type: "application/vnd.pdf" }))
          const link = document.createElement("a")
          link.href = url
          link.setAttribute("download", "Pedido.pdf")
          document.body.appendChild(link)
          link.click()
        } catch (error) {
          this.$store.commit("setAlert", {
              color: "danger",
              message: "Ocurrio un error al generar el archivo PDF.",
              show: 5
            })
        } finally {
          this.loading = false
        }
      },
      async printOrderPDF(idDocument) {
        this.loading = true

        try {
          const { response } = await descargarCotizacionPDF(this, idDocument)
          const { nombreArchivo, contenidoArchivo } = response

          downloadFileObject(nombreArchivo, "pdf", contenidoArchivo)
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error al generar el archivo PDF",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      toggleDocument(e, item){
        e.stopPropagation();
        e.preventDefault();

        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
      getBadgeColor(estado) {
        if (estado === "PE") return 'warning'

        if (estado === "EM") return "success"
        if (estado === "TO") return "success"
        // // if (estado === "PE") return "danger"
        // if (estado === "DE") return "danger"
        if (estado === "PC") return "danger"


        // Estados del Usuario
        // CA - Cargado
        // PA - Pendiente Aprobación
        // AP - Aprobado
        // RA - Rechazado Aprobador

        // Estados Empresa
        // PE - Pendiente
        // AL - Alistamiento
        // MD - Mercancía Despachado
        // ME - Mercancía Entregada
        // EP - Entrega Parcial
        // ER - Entrega Rechazada
        // TO - Facturado
        // PC - Pedido Cancelado

      },
      openRightSidebarComments(e, item) {
        e.stopPropagation();
        e.preventDefault();

        console.log(item);

        this.showRightSidebarComments = true
      },
      openPanelUploadAttachment(e, idDocument) {
        e.stopPropagation();
        e.preventDefault();
  
        this.idDocumento = idDocument
        this.updateComponentAttachments++
        this.showPanelUploadAttachment = true
      },
      openPanelAttachments(e, idDocument) {
        e.stopPropagation();
        e.preventDefault();
  
        this.showPanelAttachments = true
        this.idDocumento = idDocument
        this.updateComponentAttachments++
      },
      closePanelAttachments() {
        this.showPanelUploadAttachment = false
      }
    },
    mounted() {
      this.getData()
    }
  })
</script>
